/******************************************************************************
   NAME:       TSVH
   AUTHOR:     Duynh
******************************************************************************/

import { Component, OnInit, Input, ViewChild, ElementRef, ViewEncapsulation, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { Message } from 'primeng/components/common/message';
import { UserService, DanhMucService, DatetimeService, TSPTService } from 'app/services/index';
import { environment } from 'environments/environment';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/pagination.component';
import * as moment from 'moment';
import { UIChart } from 'primeng/chart';
import { Chart } from 'chart.js';
const userLocalName = environment.LOCAL_USER_NAME;


@Component({
  selector: 'app-thongsophutai-chitiet',
  templateUrl: './thongsophutai-chitiet.component.html',
  styleUrls: ['./thongsophutai-chitiet.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TSPTChiTietComponent implements OnInit, AfterViewInit, OnChanges {

  // khai báo chartjs
  chart: any = [];
  chartDrew: boolean = false;
  // quay quay
  isShowProgress: number = 0;

  // tham số truy vấn
  maxDate: Date;

  paraQuerySocongto: any;
  paraQueryTuNgay: any;
  paraQueryDenNgay: any;
  totalRows: number = 0;
  totalPage: number = 0;
  currentPage: number = 0;
  rowsNumber: number = 20;

  // mảng lưu giá trị và vẽ theo trang
  lsttspt: any = [];
  lsttspt_bieudo: any = [];
  lstReturntspt: any = [];
  dataExcel: string;

  // danh sách công tơ
  lstSocongto: any = [];

  // vẽ biểu đồ
  loaiThongso: string = "ptonggiao";

  // input truyền vào từ cha
  @Input() meterid: number;
  @Input() tendiemdo: number;
  @Input() selected_date: Date;
  @Input() dongcongto: string;

  // thông báo
  msgs: Message[];
  @ViewChild('canvastspt') canvastspt: ElementRef;
  constructor(
    private user: UserService,
    private danhMucService: DanhMucService,
    private dateService: DatetimeService,
    private tsptService: TSPTService) {

  }

  // event

  ngOnInit() {
    this.maxDate = new Date();
    this.paraQueryTuNgay = this.selected_date;
    this.paraQueryDenNgay = this.selected_date;
    // this.layDScongto();
    this.paraQuerySocongto = '0';

  }
  ngOnChanges(changes: SimpleChanges) {
    this.layDScongto();
  }
  ngAfterViewInit(): void {

  }

  public chartTypeChange() {
    this.drawChart();
  }

  // chuyển trang
  public onPageChange(page: number): void {
    page = Number(page);

    if (this.isShowProgress === 1) return;
    if (this.totalRows <= 0) return;
    if (page < 0) return;
    if (page > this.totalPage - 1) return;
    if (page === this.currentPage) return;

    this.loadPage(page);
  }

  // thay đổi size page
  public onSizeChange() {
    this.rowsNumber = Number(this.rowsNumber);
    this.currentPage = 0;
    this.loadPage(0);
  }


  public thuchien(): void {
    this.laydulieu();
  }
  // loa danh sách công tơ
  public layDScongto(): void {
    this.meterid
    this.tsptService.getDsCongto(
      this.meterid).subscribe(response => {
        let dataRet = (response);
        this.lstSocongto = [];
        this.lstSocongto.push({ label: "--Tất cả--", value: 0 });
        dataRet.data.forEach((item, index) => {
          this.lstSocongto.push({ label: item.socongto, value: item.sct_value });
        });
        this.laydulieu();
      });
  }
  public laydulieu() {
    this.msgs = [];

    const diff = this.paraQueryDenNgay - this.paraQueryTuNgay;

    if (diff < 0) {
      this.msgs.push({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Vui lòng "Từ ngày" nhỏ hơn "Đến ngày"'
      });
      return;
    }

    this.currentPage = 0;
    this.loadPage(0);
    this.laydulieu_bieudo();
  }
  private loadPage(page: number = 0) {

    this.isShowProgress = 1;

    const curUser = JSON.parse(localStorage.getItem(userLocalName));

    const pageSize = Number(this.rowsNumber);

    const skip = page;
    const limit = pageSize;

    this.tsptService.getTSPT_KHACHHANG(
      curUser.mataikhoan,
      this.meterid,
      this.paraQuerySocongto,
      this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay),
      this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay),
      skip,
      limit,
      "",
      3
    ).subscribe(response => {

      const dataRet = response;

      this.dataExcel = dataRet;

      if (dataRet && dataRet.data && dataRet.data.length > 0) {

        this.lsttspt = dataRet.data;
        this.lstReturntspt = dataRet.data;

        this.currentPage = page;

        this.totalRows = dataRet.data[0].rowscount || 0;

        this.totalPage = Math.ceil(this.totalRows / pageSize);
        // vẽ sau khi Angular cập nhật DOM
        setTimeout(() => {
          this.chartTypeChange();
        }, 0);

      } else {

        this.lsttspt = [];
        this.lstReturntspt = [];
        this.dataExcel = "";

        this.currentPage = 0;
        this.totalRows = 0;
        this.totalPage = 0;

        if (this.chartDrew) {
          this.chart.destroy();
          this.chartDrew = false;
        }
      }

      this.isShowProgress = 0;

    }, error => {

      console.error(error);

      this.isShowProgress = 0;
    });
  }
  public laydulieu_bieudo() {
    this.isShowProgress = 1;
    let diff = this.paraQueryDenNgay - this.paraQueryTuNgay;
    if (diff < 0) {
      return;
    }
    let curUser = JSON.parse(localStorage.getItem(userLocalName));
    this.tsptService.getTSPT_KHACHHANG(
      curUser.mataikhoan,
      this.meterid,
      this.paraQuerySocongto,
      this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay),
      this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay),
      0,
      10000,
      "",
      3).subscribe(response => {

        let dataRet = (response);
        if (dataRet.data.length > 0) {
          this.lsttspt_bieudo = dataRet.data;
          this.chartTypeChange();
        }
        else {
          this.lsttspt_bieudo = [];
        }
        this.isShowProgress = 0;
      });
  }

  public drawChart() {

    if (this.lsttspt_bieudo.length == 0) {
      if (this.chartDrew) {
        this.chart.destroy();
        this.chartDrew = false;
      }
      return;
    }

    let labels = [];
    let data = [];
    let Colors = [];
    let donvi_doluong: string = "";
    this.lsttspt_bieudo.reverse();


    this.lsttspt_bieudo.forEach((item, index) => {
      labels.push(item.starttime);
      Colors.push(this.GetColorByTimeDl(item.starttime))
      switch (this.loaiThongso) {
        case "ptonggiao": {
          data.push(item.importkw);
          donvi_doluong = "P tổng giao (KW)";
          break;
        }
        case "ptongnhan": {
          data.push(item.exportkw);
          donvi_doluong = "P tổng nhận(KW)";
          break;
        }
        case "qtonggiao": {
          data.push(item.c1);
          donvi_doluong = "Q tổng giao (KVAR)";
          break;
        }
        case "qtongnhan": {
          data.push(item.c2);
          donvi_doluong = "Q tổng nhận(KVAR)";
          break;
        }
        case "sl_pgiaotong": {
          data.push(item.sl_pgiaotong);
          donvi_doluong = "SL P GIAO (kWh)";
          break;
        }
        case "sl_pnhantong": {
          data.push(item.sl_pnhantong);
          donvi_doluong = "SL P NHẬN (kWh)";
          break;
        }
        case "sl_qgiaotong": {
          data.push(item.sl_qgiaotong);
          donvi_doluong = "SL Q GIAO (kVARh)";
          break;
        }
        case "sl_qnhantong": {
          data.push(item.sl_qnhantong);
          donvi_doluong = "SL Q NHẬN (kVARh)";
          break;
        }
      };
    });

    this.lsttspt_bieudo.reverse();


    if (this.chartDrew) {
      this.chart.destroy();
      this.chartDrew = false;
    }
    this.chart = new Chart('canvastspt', {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: '',
            data: data,
            backgroundColor: Colors,
            fill: true,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: donvi_doluong
            },
            ticks: {
              min: 0
            }
          }]
        },
        chartArea: {
          backgroundColor: '#FFF'
        }
      },
      plugins: [{
        beforeInit: function (chart, options) {

        },
        beforeDraw: function (chart, easing) {
          if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
            var helpers = Chart.helpers;
            var ctx = chart.chart.ctx;
            //var chartArea = chart.chartArea;
            var canvas = chart.chart.canvas


            ctx.save();
            ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.restore();
          }
        }
      }]
    })
    this.chartDrew = true;
  }


  // lấy màu sắc theo time
  private GetColorByTimeDl(time) {

    let datetime = moment(time, 'DD/MM/YYYY HH:mm')
    var day = datetime.day();
    var timeTemp = time.split(' ')[1].split(':');
    var minuteCheck = (parseInt(timeTemp[0]) * 60) + parseInt(timeTemp[1]);

    // Khung giờ thấp điểm  - Tất cả các ngày trong tuần
    var thapdiem1Tu = 22 * 60;
    var thapdiem1Den = 24 * 60;
    var thapdiem2Tu = 0;
    var thapdiem2Den = 4 * 60;
    if ((minuteCheck >= thapdiem1Tu && minuteCheck <= thapdiem1Den) || (minuteCheck >= thapdiem2Tu && minuteCheck < thapdiem2Den)) {
      return "#8bbc21";
    }
    else {
      // Ngày chủ nhật
      if (day == 0) {
        // Giờ bình thường
        return "#f58220";
      } else {
        var binhthuong1Tu = 4 * 60;
        var binhthuong1Den = (9 * 60) + 30;

        var binhthuong2Tu = (11 * 60) + 30;
        var binhthuong2Den = (17 * 60);

        var binhthuong3Tu = (20 * 60);
        var binhthuong3Den = (22 * 60);

        if ((minuteCheck >= binhthuong1Tu && minuteCheck < binhthuong1Den) || (minuteCheck >= binhthuong2Tu && minuteCheck < binhthuong2Den) || (minuteCheck >= binhthuong3Tu && minuteCheck < binhthuong3Den)) {
          return "#f58220";
        } else {
          return "#ff0000";
        }
      }
    }
  }
  public exceltspt() {
    this.isShowProgress = 1;
    let title = "THÔNG SỐ PHỤ TẢI";
    let header = "";
    let ngayxuatdulieu: Date = new Date();
    if (this.paraQueryTuNgay == this.paraQueryDenNgay) {
      header = this.tendiemdo + ",Ngày xuất dữ liệu: " + this.dateService.convertDatetoDateOnlyString(ngayxuatdulieu) + ",Có " + this.totalRows + " bản ghi trong ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay);
    } else {
      header = this.tendiemdo + ",Ngày xuất dữ liệu: " + this.dateService.convertDatetoDateOnlyString(ngayxuatdulieu) + ",Có " + this.totalRows + " bản ghi. Từ ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay) + " - Đến ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay);
    }
    let curUser = JSON.parse(localStorage.getItem(userLocalName));
    this.tsptService.getTSPT_EXCEL_KHACHHANG(this.meterid, this.paraQuerySocongto, curUser.mataikhoan
      , title
      , this.tendiemdo + ' - THÔNG SỐ PHỤ TẢI - Từ ngày: ' + this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay) + " Đến ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay) + '.xlsx'
      , this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay)
      , this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay)
      , this.dongcongto, header).subscribe(response => {
        this.isShowProgress = 0;
      });
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/giam-sat/thong-so-phu-tai/chi-tiet/thongsophutai-chitiet.component.ts